import { useState } from 'react'

import { Box, Fab, Popover, Slider, Tooltip, Typography } from '@mui/material'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'

type SoundControlProps = {
  initialGain?: number
  onGainChange?: (gain: number) => void
}

export default function AudioGainControl({ initialGain = 5, onGainChange }: SoundControlProps) {
  const [gain, setGain] = useState(initialGain) // Start with a default gain value
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'gain-popover' : undefined

  const handleGainChange = (_event: Event, newValue: number | number[]) => {
    setGain(newValue as number)
    onGainChange?.(newValue as number)
  }

  return (
    <Box display="flex" alignItems="center">
      <Tooltip title="Adjust Volume Gain">
        <Fab color="primary" onClick={handlePopoverOpen} size="small">
          <VolumeUpIcon />
        </Fab>
      </Tooltip>
      <Typography variant="caption" sx={{ ml: 1 }}>
        Gain: x{gain.toFixed(1)}
      </Typography>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box width={200} p={2}>
          <Typography gutterBottom>Adjust Gain (0 to 40)</Typography>
          <Slider aria-labelledby="gain-slider" value={gain} onChange={handleGainChange} step={0.5} min={0} max={40} valueLabelDisplay="auto" />
        </Box>
      </Popover>
    </Box>
  )
}
